import { Dispatch, SetStateAction } from "react";
import NextBtn from "../common/NextBtn";
import PreviousBtn from "../common/PreviousBtn";
import FloatingSideSheet, { placeInfoType } from "../map/floatingsidesheet/FloatingSideSheet";
import PlaceInfo from "./PlaceInfo";
import styles from "./PlaceInfoSetting.module.css";
import commonStyles from "./CreateMapSetting.module.css";
import ContentTitle from "../common/ContentTitle";
import { MainImageType } from "./CreateMap";

interface PlaceInfoSettingProps {
    processIdx: number;
    progressProcess: (n: number) => void;
    mapSettingData: {
        placeInfo: placeInfoType;
    };
    sampleData: { row1: string[]; row2: string[] };
    setMapSettingData: Dispatch<
        SetStateAction<{
            placeInfo: placeInfoType;
        }>
    >;
    mainImage: MainImageType;
    setMainImage: Dispatch<SetStateAction<MainImageType>>;
}
/**
 * @author cjs
 * @date 2024-09-27 10:37:23
 * @remark 지도만들기 장소 정보 설정 컴포넌트
 * @pram props
 * @props PlaceInfoSettingProps
 *      processIdx(required) : 지도만들기 화면 순서
        progressProcess(required) : 지도만들기 화면 순서 변경 함수
        sampleData(required) : 마커 설정과 장소 정보 설정에 미리 보여주기 위한 예제 데이터
        mapSettingData(required) : 장소 정보 데이터
        setMapSettingData(required) : 장소 정보 데이터 변경 함수
 * @returns PlaceInfoSetting
 */

function PlaceInfoSetting(props: PlaceInfoSettingProps) {
    return (
        <>
            <div className={styles.wrapPreView}>
                <FloatingSideSheet
                    mapData={props.sampleData}
                    mapSettingData={props.mapSettingData}
                    setMapSettingData={props.setMapSettingData}
                    mainImage={props.mainImage}
                />
            </div>
            <div className={`${commonStyles.wrap} undraggable`}>
                <div className={commonStyles.container}>
                    <div className={commonStyles.title}>
                        <ContentTitle title="장소정보설정" />
                    </div>
                    {
                        // changeDataToFieldValue 내부로 이동
                        <PlaceInfo
                            mapData={props.sampleData}
                            mapSettingData={props.mapSettingData}
                            setMapSettingData={props.setMapSettingData}
                            setMainImage={props.setMainImage}
                        />
                    }
                    <div className={commonStyles.footer}>
                        <div className={commonStyles.wrapProgressBtn}>
                            <div className={`${props.processIdx === 0 ? commonStyles.hideBtn : commonStyles.activeBtn}`}>
                                <PreviousBtn progressProcess={props.progressProcess} />
                            </div>
                            <NextBtn progressProcess={props.progressProcess} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PlaceInfoSetting;
